import { Handler } from "../common/types";
import { MsgBusActions } from "../common/events";

export const loaded: Handler = (_, { msgBus }) => {
  msgBus.publish(MsgBusActions.WIDGET_LOADED, true);
};
